import * as yup from 'yup';

import {
  StringWidgetType,
  StringWidget,
  BaseWidgetSpec,
  WidgetType,
  TextWidgetSpec,
  NumberWidgetType,
  NumberWidget,
  NumberWidgetSpec,
  ToggleWidgetSpec,
  BooleanWidgetType,
  BooleanWidget,
	CheckboxWidgetSpec,
} from '../../../client/forms/widgets';

/**
 * Base schema for a {@link FormField} widget.
 */
const baseWidgetSchema: yup.SchemaOf<BaseWidgetSpec<keyof typeof WidgetType>> = yup
  .object({
    type: yup.mixed().required().oneOf(Object.keys(WidgetType)),
  })
  .required();

/**
 * {@link TextWidgetSpec} schema.
 */
const textWidgetSchema: yup.SchemaOf<TextWidgetSpec> = baseWidgetSchema.clone().shape({
  type: yup.string().equals([WidgetType.Text]).required(),
  placeholder: yup.string().optional(),
});

export const StringWidgetSchemaMap: Record<
  keyof typeof StringWidgetType,
  yup.SchemaOf<StringWidget>
> = {
  Text: textWidgetSchema,
};

/**
 * {@link NumberWidgetSpec} schema.
 */
const numberWidgetSchema: yup.SchemaOf<NumberWidgetSpec> = baseWidgetSchema.clone().shape({
  type: yup.string().equals([WidgetType.Number]).required(),
  placeholder: yup.string(),
  min: yup.number(),
  max: yup.number(),
});

export const NumberWidgetSchemaMap: Record<
  keyof typeof NumberWidgetType,
  yup.SchemaOf<NumberWidget>
> = {
  Number: numberWidgetSchema,
};

/**
 * {@link ToggleWidgetSpec} schema.
 */
const toggleWidgetSchema: yup.SchemaOf<ToggleWidgetSpec> = baseWidgetSchema.clone().shape({
  type: yup.mixed<ToggleWidgetSpec['type']>().equals([WidgetType.Toggle]).required(),
});

const checkboxWidgetSchema: yup.SchemaOf<CheckboxWidgetSpec> = baseWidgetSchema.clone().shape({
  type: yup.mixed<CheckboxWidgetSpec['type']>().equals([WidgetType.Checkbox]).required(),
});

/**
 * {@link BooleanWidgetSpec} schema.
 */
export const BooleanWidgetSchemaMap: Record<
  keyof typeof BooleanWidgetType,
  yup.SchemaOf<BooleanWidget>
> = {
  Toggle: toggleWidgetSchema,
  Checkbox: checkboxWidgetSchema,
};
